import { render, staticRenderFns } from "./SendModal.vue?vue&type=template&id=042ac94e&scoped=true"
import script from "./SendModal.vue?vue&type=script&lang=js"
export * from "./SendModal.vue?vue&type=script&lang=js"
import style0 from "./SendModal.vue?vue&type=style&index=0&id=042ac94e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042ac94e",
  null
  
)

export default component.exports